import Axios from 'axios';
import { type MaybeRef } from 'vue';

export function useSendAppDownloadLink(mobile: MaybeRef<string>) {
    const loading = ref(false);
    const submit = async () => {
        const mobileNumber = toValue(mobile);
        if (!/09\d{9}/.test(convertPersianNumbers(mobileNumber))) {
            swal({
                text: 'لطفا شماره تلفن را به‌صورت 09xxxxxxxxx وارد کنید.',
                icon: 'warning',
                confirmButtonText: 'باشه',
            });
            return;
        }
        loading.value = true;
        try {
            await Axios.post(
                `${useBaseUrls().content}/sms/get_app/send?to=${mobileNumber}`,
                undefined,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            swal({
                text: 'پیامک با موفقیت ارسال شد!',
                icon: 'success',
                confirmButtonText: 'باشه',
            });
            loading.value = false;
        } catch (error) {
            handleException(error);
            loading.value = false;
        }
    };
    return { loading, submit };
}
